import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./Layout";
import Dashboard from "./Dashboard";
import Lists from "./Lists";
import AddList from "./AddList";
import EditList from "./EditList";
import { AuthProvider } from "./AuthProvider";
import RequireAuth from "./RequireAuth";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import Products from "./Products";
import ProductsUpdate from "./ProductsUpdate";
import AccountUsers from "./AccountUsers";
import AddUserAccount from "./AddUserAccount";
import EditUserAccount from "./EditUserAccount";
import SMS from "./SMS";
import SmsMessages from "./SmsMessages";
import AddTemplate from "./AddTemplate";
import EditTemplate from "./EditTemplate";
import { useEffect } from "react";

const PROJECT_NAME = "Lenderspark";

function App() {
	useEffect(() => {
		document.title = PROJECT_NAME;
	}, []);

	return (
		<BrowserRouter future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
			<AuthProvider>
				<Routes>
					<Route path="login" element={<Login />} />
					<Route path="forgot-password" element={<ForgotPassword />} />
					<Route path="reset-password" element={<ResetPassword />} />
					<Route path="/" element={<Layout />}>
						<Route element={<RequireAuth />}>
							<Route index element={<Navigate to="/dashboard" replace />} />
							<Route path="/dashboard/*" element={<Dashboard />} />
							<Route path="/products" element={<Products />} />
							<Route path="/update-products" element={<ProductsUpdate />} />
							<Route path="/lists" element={<Lists />} />
							<Route path="/add-list" element={<AddList />} />
							<Route path="/edit-list/:listId" element={<EditList />} />
							<Route path="/account-users" element={<AccountUsers />} />
							<Route path="/add-account-users" element={<AddUserAccount />} />
							<Route path="/edit-account-user/:userId" element={<EditUserAccount />} />
							<Route path="/sms" element={<SMS />} />
							<Route path="/messages" element={<SmsMessages />} />
							<Route path="/add-template" element={<AddTemplate />} />
							<Route path="/edit-template/:templateId" element={<EditTemplate />} />
						</Route>
					</Route>
				</Routes>
			</AuthProvider>
		</BrowserRouter>
	);
}

export default App;
